import {
	createAudience200Schema,
	createAudienceMember200Schema,
	createAudienceMemberRequestSchema,
	createAudienceMutationRequestSchema,
	deleteAudience200Schema,
	deleteAudiencePathParamsSchema,
	listAudiences200Schema,
	listAudiencesQueryParamsSchema,
	searchAudience200Schema,
	searchAudienceMembers200Schema,
	searchAudienceMembersQueryParamsSchema,
	searchAudienceMutationRequestSchema,
} from "../schemas/audienceApi.schemas";
import type {
	CreateAudienceMemberResponse,
	CreateAudienceResponse,
	DeleteAudienceResponse,
	ListAudiencesResponse,
	SearchAudienceMembersResponse,
	SearchAudienceResponse,
} from "../types/audienceApi.types";

export const audienceEndpointContract = {
	listAudiences: {
		path: "/m/audiences",
		method: "GET" as const,
		querySchema: listAudiencesQueryParamsSchema,
		responseSchema: listAudiences200Schema,
		responseType: {} as ListAudiencesResponse,
	},
	searchAudience: {
		path: "/m/audiences/find",
		method: "POST" as const,
		requestSchema: searchAudienceMutationRequestSchema,
		responseSchema: searchAudience200Schema,
		responseType: {} as SearchAudienceResponse,
	},
	createAudience: {
		path: "/m/audiences",
		method: "POST" as const,
		requestSchema: createAudienceMutationRequestSchema,
		responseSchema: createAudience200Schema,
		responseType: {} as CreateAudienceResponse,
	},
	deleteAudience: {
		path: "/m/audiences/:audienceGroupId",
		method: "DELETE" as const,
		pathSchema: deleteAudiencePathParamsSchema,
		responseSchema: deleteAudience200Schema,
		responseType: {} as DeleteAudienceResponse,
	},
	searchAudienceMembers: {
		path: "/m/audiences/members",
		method: "GET" as const,
		querySchema: searchAudienceMembersQueryParamsSchema,
		responseSchema: searchAudienceMembers200Schema,
		responseType: {} as SearchAudienceMembersResponse,
	},
	createAudienceMember: {
		path: "/m/audiences/members",
		method: "POST" as const,
		requestSchema: createAudienceMemberRequestSchema,
		responseSchema: createAudienceMember200Schema,
		responseType: {} as CreateAudienceMemberResponse,
	},
} as const;
